// extracted by mini-css-extract-plugin
export default {"mainDiv":"Wings_mainDiv__isq3f","checkbox":"Wings_checkbox__B7b5z","container":"Wings_container__DUGKA","checkmark":"Wings_checkmark__sZHav"};